import { IVehicle } from "dataModels/contract";
import React from "react";
import { useTranslation } from "react-i18next";
import { VehicleType, Affirmation, Direction } from "shared/constants";
import { Container, Row, Col } from "react-grid-system"
import { Output } from "@ds/ds-snam/react";
/*
    Vehicle info component, it will be shared as it's the same between vehicle insert/edit form review and vehicle sheet
*/
interface IVehicleDataInfo {
    vehicle: IVehicle,
    excludeFields: string[],
    isData:boolean
}
const VehicleDataInfo: React.FC<IVehicleDataInfo> = (props): JSX.Element => {
    const { vehicle, excludeFields } = props;
    const { t } = useTranslation(['contract', 'app']);

    const getAffirmationValue = (value: string) => {
        return value === Affirmation.NO ? t('general.noLabel', { ns: 'app' }) : t('general.yesLabel', { ns: 'app' });
    }

    const getDirection = (value: Direction) => {
        return t('vehicle.vehicleData.loadingDirections.' + value);
    }

    const kgLabel = t('vehicle.vehicleForm.sections.dataInput.fieldDesc.0');
    const m3Label = t('vehicle.vehicleForm.sections.dataInput.fieldDesc.1');
    const barLabel = t('vehicle.vehicleForm.sections.dataInput.fieldDesc.2');
    const hLabel = t('vehicle.vehicleForm.sections.dataInput.fieldDesc.3');
    const percentVolumeLabel = t('vehicle.vehicleForm.sections.dataInput.fieldDesc.4');

    /** Common fields between tanker and IsoContainer type */
    const getTankerSharedFields = () => {
        return <>
            {/* Empty weight */}
            <Output
                outputTitle={t('vehicle.vehicleData.headers.0')}
                outputText={vehicle.emptyWeight+" "+kgLabel}
                style={{marginBottom:'16px'}}
            ></Output>  
            {/*<p className="driverDataBoxTitle">
                {t('vehicle.vehicleData.headers.0')}
            </p>
            <div className="driverDataBoxText">
                <p>{vehicle.emptyWeight} {kgLabel}</p>
            </div>*/}
            {/** Volume*/}
            <Output
                outputTitle={t('vehicle.vehicleData.headers.3')}
                outputText={vehicle.volume+" "+m3Label}
                style={{marginBottom:'16px'}}
            ></Output>
            {/*<p className="driverDataBoxTitle">
                {t('vehicle.vehicleData.headers.3')}
            </p>
            <div className="driverDataBoxText">
                <p>{vehicle.volume} {m3Label}</p>
            </div>*/}
            {/** Design pressure */}
            <Output
                outputTitle={t('vehicle.vehicleData.headers.4')}
                outputText={vehicle.designPressure+" "+barLabel}
                style={{marginBottom:'16px'}}
            ></Output>
            {/*<p className="driverDataBoxTitle">
                {t('vehicle.vehicleData.headers.4')}
            </p>
            <div className="driverDataBoxText">
                <p>{vehicle.designPressure} {barLabel}</p>
            </div>*/}
        </>
    }

    return (
        <>
            <div className="externalCustomerDataContainer" style={{padding:props.isData?"0px":"24px"}}>
                {!props.isData && <Row>
                    <Col>
                        <p className="formSubTitle">
                            {/*Riepilogo componente*/}
                            {t('vehicle.vehicleForm.sections.review.title')}
                        </p>
                    </Col>
                </Row>}
                {vehicle.type === VehicleType.TRUCK && <>
                    <Row>
                        {/*Licence plate */}
                        {<Col hidden={excludeFields.includes("licencePlate")} xs={12} md={3}>
                            <Output
                                outputTitle= {t('vehicle.vehicleForm.sections.dataInput.fields.0')}
                                outputText={vehicle.licencePlate}
                                style={{marginBottom:'16px'}}
                            ></Output>
                            {/*<p className="driverDataBoxTitle">
                                {t('vehicle.vehicleForm.sections.dataInput.fields.0')}
                            </p>
                            <div className="driverDataBoxText">
                                <p>{vehicle.licencePlate}</p>
                            </div>*/}
                        </Col>}

                        <Col xs={12} md={3}>
                            {/** Empty weight */}
                            <Output
                                outputTitle= {t('vehicle.vehicleData.headers.0')}
                                outputText={vehicle.emptyWeight+" "+kgLabel}
                                style={{marginBottom:'16px'}}
                            ></Output>
                            {/*<p className="driverDataBoxTitle">
                                {t('vehicle.vehicleData.headers.0')}
                            </p>
                            <div className="driverDataBoxText">
                                <p>{vehicle.emptyWeight} {kgLabel}</p>
                            </div>*/}
                        </Col>

                        <Col xs={12} md={3}>
                            {/*Presence of a flame arrester*/}
                            <Output
                                outputTitle= {t('vehicle.vehicleData.headers.2')}
                                outputText={getAffirmationValue(vehicle.flameArrest)}
                                style={{marginBottom:'16px'}}
                            ></Output>
                            {/*<p className="driverDataBoxTitle">
                                {t('vehicle.vehicleData.headers.2')}
                            </p>
                            <div className="driverDataBoxText">
                                <p>{getAffirmationValue(vehicle.flameArrest)}</p>
                            </div>*/}
                        </Col>
                        
                        <Col xs={12} md={3}>
                            {/*Grounding connection and fitting*/}
                            {/*<Output
                                outputTitle= {t('vehicle.vehicleData.headers.1')}
                                outputText={getAffirmationValue(vehicle.groundingConnection)}
                                style={{marginBottom:'16px'}}
                            ></Output>*/}
                            {/*<p className="driverDataBoxTitle">
                                {t('vehicle.vehicleData.headers.1')}
                            </p>
                            <div className="driverDataBoxText">
                                <p>{getAffirmationValue(vehicle.groundingConnection)}</p>
                            </div>*/}
                        </Col>


                        
                    </Row>
                </>}

                {vehicle.type === VehicleType.TANKER &&
                    <Row>

                        <Col>
                            {/** Licence plate */}
                            {!excludeFields.includes("licencePlate") &&
                                <>
                                    <Output
                                        outputTitle= {t('vehicle.vehicleForm.sections.dataInput.fields.0')}
                                        outputText={vehicle.licencePlate}
                                        style={{marginBottom:'16px'}}
                                    ></Output>
                                    {/*<p className="driverDataBoxTitle">
                                        {t('vehicle.vehicleForm.sections.dataInput.fields.0')}
                                    </p>
                                    <div className="driverDataBoxText">
                                        <p>{vehicle.licencePlate}</p>
                                    </div>*/}
                                </>
                            }

                            
                            {/* Empty weight, Volume, Design pressure */}
                            {getTankerSharedFields()}

                            {/** Maximum filling degree */}
                            <Output
                                outputTitle={t('vehicle.vehicleData.headers.5')}
                                outputText={vehicle.maxFillingDegree+" "+percentVolumeLabel}
                                style={{marginBottom:'16px'}}
                            ></Output>
                            {/*<p className="driverDataBoxTitle">
                                {t('vehicle.vehicleData.headers.5')}
                            </p>
                            <div className="driverDataBoxText">
                                <p>{vehicle.maxFillingDegree} {percentVolumeLabel}</p>
                            </div>*/}
                        </Col>

                        <Col>
                            {/* Maximum filling weight*/}
                            {/*<p className="driverDataBoxTitle">
                                {t('vehicle.vehicleData.headers.6')}
                            </p>
                            <div className="driverDataBoxText">
                                <p>{vehicle.maxFillingWeight} {kgLabel}</p>
                            </div>*/}

                            {/*  Confirmation that the Truck has a vacuum thermal insulation */}
                            <Output
                                outputTitle={t('vehicle.vehicleData.headers.7')}
                                outputText={getAffirmationValue(vehicle.vacuumIsolation)}
                                style={{marginBottom:'16px'}}
                            ></Output>
                            {/*<p className="driverDataBoxTitle">
                                {t('vehicle.vehicleData.headers.7')}
                            </p>
                            <div className="driverDataBoxText">
                                <p>{getAffirmationValue(vehicle.vacuumIsolation)}</p>
                            </div>*/}
                            {/* Manufacturer */}
                            <Output
                                outputTitle={t('vehicle.vehicleData.headers.8')}
                                outputText={vehicle.manufacturer}
                                style={{marginBottom:'16px'}}
                            ></Output>
                            {/*<p className="driverDataBoxTitle">
                                {t('vehicle.vehicleData.headers.8')}
                            </p>
                            <div className="driverDataBoxText">
                                <p>{vehicle.manufacturer}</p>
                            </div>*/}
                            {/* Year of Manufacture */}
                            <Output
                                outputTitle={t('vehicle.vehicleData.headers.9')}
                                outputText={vehicle.yearManufacture}
                                style={{marginBottom:'16px'}}
                            ></Output>
                            {/*<p className="driverDataBoxTitle">
                                {t('vehicle.vehicleData.headers.9')}
                            </p>
                            <div className="driverDataBoxText">
                                <p>{vehicle.yearManufacture}</p>
                            </div>*/}

                        </Col>

                        <Col>

                            {/*Two independent level indicators*/}
                            <Output
                                outputTitle={t('vehicle.vehicleData.headers.10')}
                                outputText={getAffirmationValue(vehicle.twoLevelsIndicators)}
                                style={{marginBottom:'16px'}}
                            ></Output>
                            {/*<p className="driverDataBoxTitle">
                                {t('vehicle.vehicleData.headers.10')}
                            </p>
                            <div className="driverDataBoxText">
                                <p>{getAffirmationValue(vehicle.twoLevelsIndicators)}</p>
                            </div>*/}

                            {/** Grounding connection and fittings compatible with the Terminal */}
                            {/*<Output
                                outputTitle={t('vehicle.vehicleData.headers.11')}
                                outputText={getAffirmationValue(vehicle.twoLevelsIndicators)}
                                style={{marginBottom:'16px'}}
                            ></Output>*/}
                            {/*<p className="driverDataBoxTitle">
                                {t('vehicle.vehicleData.headers.11')}
                            </p>
                            <div className="driverDataBoxText">
                                <p>{getAffirmationValue(vehicle.twoLevelsIndicators)}</p>
                            </div>*/}

                            {/** Loading side */}
                            <Output
                                outputTitle={t('vehicle.vehicleData.headers.12')}
                                outputText={getDirection(vehicle.loadingSide)}
                                style={{marginBottom:'16px'}}
                            ></Output>
                            {/*<p className="driverDataBoxTitle">
                                {t('vehicle.vehicleData.headers.12')}
                            </p>
                            <div className="driverDataBoxText">
                                <p>{getDirection(vehicle.loadingSide)}</p>
                            </div>*/}

                        </Col>


                    </Row>
                }

                {vehicle.type === VehicleType.ISO_CONTAINER &&
                    <Row>
                        <Col>
                            {/** ISO Container identification code */}
                            {!excludeFields.includes("isoContainerCode") && <>
                                <Output
                                    outputTitle={t('vehicle.vehicleData.headers.14')}
                                    outputText={vehicle.isoContainerCode}
                                    style={{marginBottom:'16px'}}
                                ></Output>
                                {/*<p className="driverDataBoxTitle">
                                    {t('vehicle.vehicleData.headers.14')}
                                </p>
                                <div className="driverDataBoxText">
                                    <p>{vehicle.isoContainerCode}</p>
                                </div>*/}
                            </>
                            }

                            {/* Empty weight, Volume, Design pressure */}
                            {getTankerSharedFields()}

                        </Col>

                        <Col>
                            {/* Actual holding time */}
                            <Output
                                outputTitle={t('vehicle.vehicleData.headers.13')}
                                outputText={vehicle.holdingTime+" "+hLabel}
                                style={{marginBottom:'16px'}}
                            ></Output>
                            {/*<p className="driverDataBoxTitle">
                                {t('vehicle.vehicleData.headers.13')}
                            </p>
                            <div className="driverDataBoxText">
                                <p>{vehicle.holdingTime} {hLabel}</p>
                            </div>*/}

                            {/** Maximum filling degree */}
                            <Output
                                outputTitle={t('vehicle.vehicleData.headers.5')}
                                outputText={vehicle.maxFillingDegree+" "+percentVolumeLabel}
                                style={{marginBottom:'16px'}}
                            ></Output>
                            {/*<p className="driverDataBoxTitle">
                                {t('vehicle.vehicleData.headers.5')}
                            </p>
                            <div className="driverDataBoxText">
                                <p>{vehicle.maxFillingDegree} {percentVolumeLabel}</p>
                            </div>*/}

                            {/* Maximum filling weight*/}
                            {/*<p className="driverDataBoxTitle">
                                {t('vehicle.vehicleData.headers.6')}
                            </p>
                            <div className="driverDataBoxText">
                                <p>{vehicle.maxFillingWeight} {kgLabel}</p>
                            </div>*/}

                            {/*  Confirmation that the Truck has a vacuum thermal insulation */}
                            <Output
                                outputTitle={t('vehicle.vehicleData.headers.7')}
                                outputText={getAffirmationValue(vehicle.vacuumIsolation)}
                                style={{marginBottom:'16px'}}
                            ></Output>
                            {/*<p className="driverDataBoxTitle">
                                {t('vehicle.vehicleData.headers.7')}
                            </p>
                            <div className="driverDataBoxText">
                                <p>{getAffirmationValue(vehicle.vacuumIsolation)}</p>
                            </div>*/}

                        </Col>

                        <Col>
                            {/* Manufacturer */}
                            <Output
                                outputTitle={t('vehicle.vehicleData.headers.8')}
                                outputText={vehicle.manufacturer}
                                style={{marginBottom:'16px'}}
                            ></Output>
                            {/*<p className="driverDataBoxTitle">
                                {t('vehicle.vehicleData.headers.8')}
                            </p>
                            <div className="driverDataBoxText">
                                <p>{vehicle.manufacturer}</p>
                            </div>*/}

                            {/* Year of Manufacture */}
                            <Output
                                outputTitle={t('vehicle.vehicleData.headers.9')}
                                outputText={vehicle.yearManufacture}
                                style={{marginBottom:'16px'}}
                            ></Output>
                            {/*<p className="driverDataBoxTitle">
                                {t('vehicle.vehicleData.headers.9')}
                            </p>
                            <div className="driverDataBoxText">
                                <p>{vehicle.yearManufacture}</p>
                            </div>*/}

                            {/*Two independent level indicators*/}
                            <Output
                                outputTitle={t('vehicle.vehicleData.headers.10')}
                                outputText={getAffirmationValue(vehicle.twoLevelsIndicators)}
                                style={{marginBottom:'16px'}}
                            ></Output>
                            {/*<p className="driverDataBoxTitle">
                                {t('vehicle.vehicleData.headers.10')}
                            </p>
                            <div className="driverDataBoxText">
                                <p>{getAffirmationValue(vehicle.twoLevelsIndicators)}</p>
                            </div>*/}

                            {/** Grounding connection and fittings compatible with the Terminal */}
                            {/*<Output
                                outputTitle={t('vehicle.vehicleData.headers.11')}
                                outputText={getAffirmationValue(vehicle.groundingConnection)}
                                style={{marginBottom:'16px'}}
                            ></Output>*/}
                            {/*<p className="driverDataBoxTitle">
                                {t('vehicle.vehicleData.headers.11')}
                            </p>
                            <div className="driverDataBoxText">
                                <p>{getAffirmationValue(vehicle.groundingConnection)}</p>
                            </div>*/}



                        </Col>

                        <Col>

                            {/** Grounding connection and fittings compatible with the Terminal */}
                            {/*<Output
                                outputTitle={t('vehicle.vehicleData.headers.11')}
                                outputText={getAffirmationValue(vehicle.twoLevelsIndicators)}
                                style={{marginBottom:'16px'}}
                            ></Output>*/}
                            {/*<p className="driverDataBoxTitle">
                                {t('vehicle.vehicleData.headers.11')}
                            </p>
                            <div className="driverDataBoxText">
                                <p>{getAffirmationValue(vehicle.twoLevelsIndicators)}</p>
                            </div>*/}


                            {/** Loading side */}
                            <Output
                                outputTitle={t('vehicle.vehicleData.headers.12')}
                                outputText={getDirection(vehicle.loadingSide)}
                                style={{marginBottom:'16px'}}
                            ></Output>
                            {/*<p className="driverDataBoxTitle">
                                {t('vehicle.vehicleData.headers.12')}
                            </p>
                            <div className="driverDataBoxText">
                                <p>{getDirection(vehicle.loadingSide)}</p>
                            </div>*/}

                        </Col>

                    </Row>
                }

                {vehicle.type === VehicleType.FLOOR &&
                    <Row>
                        {/** Licence plate */}
                        {<Col hidden={excludeFields.includes("licencePlate")}>
                            <Output
                                outputTitle={t('vehicle.vehicleForm.sections.dataInput.fields.0')}
                                outputText={vehicle.licencePlate}
                                style={{marginBottom:'16px'}}
                            ></Output>
                            {/*<p className="driverDataBoxTitle">
                                {t('vehicle.vehicleForm.sections.dataInput.fields.0')}
                            </p>
                            <div className="driverDataBoxText">
                                <p>{vehicle.licencePlate}</p>
                            </div>*/}
                        </Col>}
                        <Col>
                            {/* Empty weight */}
                            <Output
                                outputTitle={t('vehicle.vehicleData.headers.0')}
                                outputText={vehicle.emptyWeight+" "+kgLabel}
                                style={{marginBottom:'16px'}}
                            ></Output>
                            {/*<p className="driverDataBoxTitle">
                                {t('vehicle.vehicleData.headers.0')}
                            </p>
                            <div className="driverDataBoxText">
                                <p>{vehicle.emptyWeight} {kgLabel}</p>
                            </div>*/}
                        </Col>

                        <Col>
                            {/** Grounding connection and fittings compatible with the Terminal */}
                            {/*<Output
                                outputTitle={t('vehicle.vehicleData.headers.11')}
                                outputText={getAffirmationValue(vehicle.groundingConnection)}
                                style={{marginBottom:'16px'}}
                            ></Output>*/}
                            {/*<p className="driverDataBoxTitle">
                                {t('vehicle.vehicleData.headers.11')}
                            </p>
                            <div className="driverDataBoxText">
                                <p>{getAffirmationValue(vehicle.groundingConnection)}</p>
                            </div>*/}

                        </Col>
                    </Row>}



            </div>

        </>)
}

export default VehicleDataInfo;